// Panels
import Panel from "./components/UIComponents/Panel/Panel.vue";
import PanelHeading from "./components/UIComponents/Panel/PanelHeading.vue";
import PanelBody from "./components/UIComponents/Panel/PanelBody.vue";
import PanelFooter from "./components/UIComponents/Panel/PanelFooter.vue";
import PanelTable from "./components/UIComponents/Panel/PanelTable.vue";

// Forms
import FormGroupInput from "./components/UIComponents/Forms/FormGroupInput.vue";
import FormGroupCpf from "./components/UIComponents/Forms/FormGroupCpf.vue";
import FormGroupSelect from "./components/UIComponents/Forms/FormGroupSelect.vue";
import FormGroupTextArea from "./components/UIComponents/Forms/FormGroupTextArea.vue";
import Checkbox from "./components/UIComponents/Forms/Checkbox.vue";
import WoodysCheckbox from "./components/UIComponents/Forms/WoodysCheckbox.vue";
import Radio from "./components/UIComponents/Forms/Radio.vue";
import FormValidator from "./components/UIComponents/Forms/FormValidator.vue";
import DropzoneUpload from "./components/UIComponents/Forms/DropzoneUpload.vue";
import ErrorMessage from "./components/UIComponents/Forms/ErrorMessage.vue";
import FormGroupSelectGroup from "./components/UIComponents/Forms/FormGroupSelectGroup.vue";
import FormGroupSearchSelect from "./components/UIComponents/Forms/FormGroupSearchSelect.vue";
import FormGroupSearchSelectMultiple from "./components/UIComponents/Forms/FormGroupSearchSelectMultiple.vue";
import FormGroupSearchSelectGroup from "./components/UIComponents/Forms/FormGroupSearchSelectGroup.vue";
import DropzoneUploadCloud from "./components/UIComponents/Forms/DropzoneUploadCloud.vue";
import FormGroupDatePicker from "./components/UIComponents/Forms/FormGroupDatePicker.vue";
import FormGroupDateRangePicker from "./components/UIComponents/Forms/FormGroupDateRangePicker.vue";
import FormGroupDateTimePicker from "./components/UIComponents/Forms/FormGroupDateTimePicker.vue";
import FormSelectMultipleGroup from "~/components/UIComponents/Forms/FormSelectMultipleGroup";
import FormSelectMultipleGroupTema from "~/components/UIComponents/Forms/FormSelectMultipleGroupTema";
import FormSelectMultipleGroupQuestao from "~/components/UIComponents/Forms/FormSelectMultipleGroupQuestao";
import QuillEditor from "~/components/UIComponents/Forms/QuillEditor";

// Buttons
import FormButton from "./components/UIComponents/Buttons/FormButton.vue";
import ButtonLink from "./components/UIComponents/Buttons/ButtonLink.vue";

// Buttons
import Alert from "./components/UIComponents/Messages/Alert.vue";
import ButtonIntegradon from "./components/UIComponents/Buttons/ButtonIntegradon.vue";

// Tabs
import HorizontalTabs from "./components/UIComponents/Tabs/HorizontalTabs.vue";
import NavTab from "./components/UIComponents/Tabs/NavTab.vue";
import TabPane from "./components/UIComponents/Tabs/TabPane.vue";

// Dropdowns
import ListDivider from "./components/UIComponents/Dropdown/ListDivider.vue";

// Collapse
import Accordion from "./components/UIComponents/Collapse/Accordion.vue";
import CollapseTitle from "./components/UIComponents/Collapse/CollapseTitle.vue";
import CollapseHeader from "./components/UIComponents/Collapse/CollapseHeader.vue";
import CollapseContent from "./components/UIComponents/Collapse/CollapseContent.vue";
import Collapse from "./components/UIComponents/Collapse/Collapse.vue";

// Modal
import Modal from "./components/UIComponents/Modal/Modal.vue";
import ModalHeader from "./components/UIComponents/Modal/ModalHeader.vue";
import ModalBody from "./components/UIComponents/Modal/ModalBody.vue";
import ModalFooter from "./components/UIComponents/Modal/ModalFooter.vue";

// Table
import DataTable from "./components/UIComponents/Tables/DataTable";
import ThSortField from "./components/UIComponents/Tables/ThSortField";
import ThNoSortField from "./components/UIComponents/Tables/ThNoSortField";

// Timeline
import Timeline from "./components/UIComponents/Timeline/Timeline.vue";
import TimelineItem from "./components/UIComponents/Timeline/TimelineItem.vue";
import TimelineBadge from "./components/UIComponents/Timeline/TimelineBadge.vue";
import TimelinePanel from "./components/UIComponents/Timeline/TimelinePanel.vue";
import TimelineHeading from "./components/UIComponents/Timeline/TimelineHeading.vue";
import TimelineBody from "./components/UIComponents/Timeline/TimelineBody.vue";
import TimelineFooter from "./components/UIComponents/Timeline/TimelineFooter.vue";
import TimelineLead from "./components/UIComponents/Timeline/TimelineLead.vue";

// BsWizard
import BsWizard from "./components/UIComponents/BsWizard/BsWizard.vue";
import BsWizardStep from "./components/UIComponents/BsWizard/BsWizardStep.vue";
import BsWizardStepnum from "./components/UIComponents/BsWizard/BsWizardStepnum.vue";
import BsWizardInfo from "./components/UIComponents/BsWizard/BsWizardInfo.vue";
import BsWizardDot from "./components/UIComponents/BsWizard/BsWizardDot.vue";

// Animation
import TransitionGroupList from "./components/UIComponents/Animation/TransitionGroupList.vue";

// Loader
import Loader from "./components/Layout/Loader";

const GlobalComponents = {
  install(Vue) {
    Vue.component(Panel.name, Panel);
    Vue.component(PanelBody.name, PanelBody);
    Vue.component(PanelHeading.name, PanelHeading);
    Vue.component(PanelFooter.name, PanelFooter);
    Vue.component(FormGroupInput.name, FormGroupInput);
    Vue.component(FormGroupCpf.name, FormGroupCpf);
    Vue.component(FormGroupTextArea.name, FormGroupTextArea);
    Vue.component(FormGroupSelect.name, FormGroupSelect);
    Vue.component(FormGroupSearchSelect.name, FormGroupSearchSelect);
    Vue.component(
      FormGroupSearchSelectMultiple.name,
      FormGroupSearchSelectMultiple
    );
    Vue.component(FormGroupSearchSelectGroup.name, FormGroupSearchSelectGroup);
    Vue.component(FormGroupDateTimePicker.name, FormGroupDateTimePicker);
    Vue.component(
      FormGroupSearchSelectMultiple.name,
      FormGroupSearchSelectMultiple
    );
    Vue.component(FormSelectMultipleGroup.name, FormSelectMultipleGroup);
    Vue.component(
      FormSelectMultipleGroupTema.name,
      FormSelectMultipleGroupTema
    );
    Vue.component(
      FormSelectMultipleGroupQuestao.name,
      FormSelectMultipleGroupQuestao
    );
    Vue.component(QuillEditor.name, QuillEditor);
    Vue.component(FormGroupDatePicker.name, FormGroupDatePicker);
    Vue.component(FormGroupDateRangePicker.name, FormGroupDateRangePicker);
    Vue.component(Checkbox.name, Checkbox);
    Vue.component(WoodysCheckbox.name, WoodysCheckbox);
    Vue.component(Radio.name, Radio);
    Vue.component(DropzoneUpload.name, DropzoneUpload);
    Vue.component(DropzoneUploadCloud.name, DropzoneUploadCloud);
    Vue.component(ErrorMessage.name, ErrorMessage);
    Vue.component(FormValidator.name, FormValidator);
    Vue.component(FormButton.name, FormButton);
    Vue.component(ButtonLink.name, ButtonLink);
    Vue.component(ListDivider.name, ListDivider);
    Vue.component(CollapseTitle.name, CollapseTitle);
    Vue.component(CollapseHeader.name, CollapseHeader);
    Vue.component(CollapseContent.name, CollapseContent);
    Vue.component(Accordion.name, Accordion);
    Vue.component(Collapse.name, Collapse);
    Vue.component(Alert.name, Alert);
    Vue.component(PanelTable.name, PanelTable);
    Vue.component(Modal.name, Modal);
    Vue.component(ModalHeader.name, ModalHeader);
    Vue.component(ModalBody.name, ModalBody);
    Vue.component(ModalFooter.name, ModalFooter);
    Vue.component(DataTable.name, DataTable);
    Vue.component(ThSortField.name, ThSortField);
    Vue.component(ThNoSortField.name, ThNoSortField);
    Vue.component(ButtonIntegradon.name, ButtonIntegradon);
    Vue.component(Timeline.name, Timeline);
    Vue.component(TimelineItem.name, TimelineItem);
    Vue.component(TimelineBadge.name, TimelineBadge);
    Vue.component(TimelinePanel.name, TimelinePanel);
    Vue.component(TimelineHeading.name, TimelineHeading);
    Vue.component(TimelineBody.name, TimelineBody);
    Vue.component(TimelineFooter.name, TimelineFooter);
    Vue.component(TimelineLead.name, TimelineLead);
    Vue.component(BsWizard.name, BsWizard);
    Vue.component(BsWizardStep.name, BsWizardStep);
    Vue.component(BsWizardStepnum.name, BsWizardStepnum);
    Vue.component(BsWizardInfo.name, BsWizardInfo);
    Vue.component(BsWizardDot.name, BsWizardDot);
    Vue.component(FormGroupSelectGroup.name, FormGroupSelectGroup);
    Vue.component(TransitionGroupList.name, TransitionGroupList);
    Vue.component(Loader.name, Loader);
    Vue.component(TabPane.name, TabPane);
    Vue.component(NavTab.name, NavTab);
    Vue.component(HorizontalTabs.name, HorizontalTabs);
  }
};

export default GlobalComponents;



// WEBPACK FOOTER //
// ./src/globalComponents.js